<template lang="pug">
AppPopover(
  ref="AppPopover"
  placement="right"
  extra-popover-classes="fc-event-container"
  lazy
)
  template(#body)
    span
      .timesheet-event-popover-head
      .popover-head-left
        .project-cell-wrapper
          .logo.valign-top.inline-block
            .avatar.avatar-medium.avatar_initial(:style="{ 'background-color': request.avatarColor }")
              | {{ request.policy_name[0].toUpperCase() }}
          .time-entry-data.inline-block
            .project
              .inline-block
                .name.strong
                  | {{ request.policy_name }}
            strong.hi-10.org-name.is-uppercase.text-lighter
              | {{ request.organization.name }}
      .popover-head-right
        .small.strong
          | {{ formattedRange }}
        .small.text-lighter
          | {{ $filters.formatDate(request.start_time) }}
    table.table-condensed.table-borderless.table
      tbody
        tr
          td.strong.no-wrap Duration:
          td
            .inline-block
              data.duration
                |
                | {{ $filters.formatDuration(request.amount_used) }}
              |
              | hrs
    .row.buttons.mt-20
      .col-xs-2.pull-right.mb-15
        a.btn.btn-sm.btn-default.pull-right(
          target="_blank"
          :href="href"
        ) View
  template(#trigger)
    slot(name="trigger")
</template>

<script>
import { formatDatetimeRange } from '~/utils/time_utils';

export default {
  name: 'TimeOffEventPopover',
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  computed: {
    href() {
      return `/time_off_requests/${this.request.id}`;
    },
    formattedRange() {
      return this.request.all_day
        ? 'All day'
        : formatDatetimeRange(this.request.start_time, this.request.stop_time, { style: 'time' });
    },
  },
};
</script>
